import { Button, ConfigProvider, Divider, message } from "antd";
import classes from "./EditManagerInfo.module.css";
import { AttachPersonToManager } from "../../shared/AttachPersonToManager/AttachPersonToManager";
import { useUnmountClearManagerInfo } from "../../../../utils/Hooks/adminManagerInfo/useUnmountClearManagerInfo";
import { useAttachPersonToManager } from "../../../../utils/Hooks/adminManagerInfo/useAttachPersonToManager";
import { ManagerForm } from "../../shared/ManagerForm/ManagerForm";
import { useForm } from "antd/es/form/Form";
import { MANAGER_FORM_ID } from "../../../../constants/adminManagerInfo/managerFormId";
import { useAppSelector } from "../../../../store/reduxHooks";
import { AdminManagerBottomPanel } from "../../shared/BottomPanel/AdminManagerBottomPanel";
import { useDispatch } from "react-redux";
import {
  editMainManagerInfo,
  setIsEditForm,
} from "../../../../store/slice/adminManagerSlice/adminManagerSlice";
import { getFullName } from "../../../../utils/utilities/getFullNameStringFromObject";
import {
  ClockCircleOutlined,
  CloseCircleOutlined,
  EditOutlined,
} from "@ant-design/icons";
import { useEditManagerMutation } from "../../../../store/api/listManager.api";

import { IManagerFormDefaultValues } from "../../../../interfaces/AdminManagerInfo/IManagerFormDefaultValues";
import { formatPhoneNumber } from "../../../../utils/utilities/formatPhoneNumber";
import { EditManagerActions } from "./EditManagerActions/EditManagerActions";
import { AttachPersonManagerList } from "../../shared/attachPersonList/AttachPersonList";

export const EditManagerInfo = () => {
  const dispatch = useDispatch();
  const currentManagerInfo = useAppSelector(
    (state) => state.adminManagerInfoSlice.currentManager,
  );

  const [editManager, { isLoading: isLoadingEditManager }] =
    useEditManagerMutation();

  const isEditForm = useAppSelector(
    (state) => state.adminManagerInfoSlice.isEditForm,
  );
  const [form] = useForm();
  const {
    attachPersonFormFinish,
    onHandleReattachPersonToCurrentManager,
    isLoadingReattach,
    isLoadingAttach,
    reattachErrorManagerName,
    reattachErrorModalOpen,
    handleCancelReattachModal,
  } = useAttachPersonToManager();

  useUnmountClearManagerInfo();

  const onEditManagerFinish = (values: IManagerFormDefaultValues) => {
    if (currentManagerInfo)
      editManager({
        ...values,
        phone_number: values.phone_number.replace(/\D/g, ""),
        patronymic: values.patronymic || "",
        id: currentManagerInfo.id,
      })
        .unwrap()
        .then(() => {
          message.success("Информация о менеджере изменена");
          dispatch(editMainManagerInfo(values));
          dispatch(setIsEditForm(!isEditForm));
        })
        .catch((err) => {
          message.error(err?.data?.message);
        });
  };

  const defaultFormValues: IManagerFormDefaultValues = {
    surname: currentManagerInfo?.surname || "",
    name: currentManagerInfo?.name || "",
    patronymic: currentManagerInfo?.patronymic || "",
    email: currentManagerInfo?.email || "",
    phone_number: currentManagerInfo?.phone_number
      ? formatPhoneNumber(currentManagerInfo?.phone_number)
      : "",
    password: currentManagerInfo?.password || "",
  };

  const isShowManagerStatus =
    currentManagerInfo?.is_banned || !currentManagerInfo?.is_enabled;

  return (
    <ConfigProvider
      theme={{
        components: {
          Form: {
            itemMarginBottom: 0,
            colorTextLabel: "rgba(0, 0, 0, 0.5)",
          },
        },
      }}
    >
      <div className={classes.header}>
        <div className={classes.managerFullName}>
          {currentManagerInfo && getFullName(currentManagerInfo)}
        </div>

        <Button
          onClick={() => {
            form.setFieldsValue(defaultFormValues);
            dispatch(setIsEditForm(!isEditForm));
          }}
          variant="link"
          size="large"
          color="default"
          className={classes.editButton}
        >
          <EditOutlined className={classes.editIcon} />
        </Button>
      </div>

      {isShowManagerStatus && (
        <div className={classes.managerStatusList}>
          {!currentManagerInfo?.is_enabled && (
            <div className={classes.managerStatusItem}>
              <ClockCircleOutlined
                className={`${classes.archiveIcon} ${classes.managerStatusIcon}`}
              />
              Пользователь в архиве
            </div>
          )}

          {currentManagerInfo?.is_banned && (
            <div className={classes.managerStatusItem}>
              <CloseCircleOutlined
                className={`${classes.blockIcon} ${classes.managerStatusIcon}`}
              />
              Пользователь заблокирован
            </div>
          )}
        </div>
      )}

      <Divider
        className={classes.divider}
        orientation="left"
        orientationMargin={0}
      >
        Информация о менеджере
      </Divider>
      <ManagerForm
        isEdit={isEditForm}
        formInstance={form}
        formId={MANAGER_FORM_ID}
        onFinish={onEditManagerFinish}
        disabled={false}
        defaultFormValues={defaultFormValues}
      />

      <EditManagerActions />

      <AttachPersonToManager
        personConnectManagerName={reattachErrorManagerName || undefined}
        cancelReconnectButtonProps={{
          onClick: handleCancelReattachModal,
        }}
        formProps={{
          onFinish: attachPersonFormFinish,
        }}
        modalProps={{
          open: reattachErrorModalOpen,
        }}
        reattachButtonProps={{
          onClick: onHandleReattachPersonToCurrentManager,
          disabled: isLoadingReattach,
          loading: isLoadingReattach,
        }}
        attachButtonProps={{
          loading: isLoadingAttach,
          disabled: isLoadingAttach,
        }}
      />

      <AttachPersonManagerList />

      {isEditForm && (
        <AdminManagerBottomPanel
          cancelButtonProps={{
            onClick: () => {
              form.setFieldsValue(defaultFormValues);
              dispatch(setIsEditForm(false));
            },
          }}
          submitButtonProps={{
            loading: isLoadingEditManager,
            disabled: isLoadingEditManager,
          }}
        />
      )}
    </ConfigProvider>
  );
};
